// These hooks re-implement the now removed useBlocker hook in 'react-router-dom'.
// Source: https://gist.github.com/rmorse/426ffcc579922a82749934826fa9f743
// Source has been modified to hold location in state so non-blocking javascript can be used.

import { useContext, useEffect, useState } from 'react'
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom'

type Navigator = any

export function useBlocker(
  blocker: (arg0: { retry(): void }) => void,
  when = true
) {
  const { navigator }: Navigator = useContext(NavigationContext)
  const [blockedLocation, setBlockedLocation] = useState(null)

  function resetLocation() {
    setBlockedLocation(null)
  }

  useEffect(() => {
    if (!when && blockedLocation) {
      navigator.push(blockedLocation)
      setBlockedLocation(null)
    } else if (!when) {
      return
    }

    const unblock = navigator.block((tx: any) => {
      setBlockedLocation(tx.location.pathname)
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock()
        },
      }

      blocker(autoUnblockingTx)
    })

    return unblock
  }, [navigator, blocker, when, blockedLocation])

  return { resetLocation }
}
